export const projectsData = [
  {
    id: 'vaidyamed-x',
    aliases: ['vaidyamedx'],
    title: 'VaidyaMed-X',
    domain: 'Healthcare Technology',
    category: 'HealthTech & Clinical AI',
    color: 'health',
    badge: 'Flagship Platform',
    shortDescription: 'An AI-powered healthcare technology platform integrating clinical knowledge retrieval, intelligent triage, and secure doctor-patient tele-collaboration.',
    fullDescription: 'VaidyaMed-X is an intelligent healthcare technology platform designed to bridge clinical care with intelligent computing. By combining specialized medical knowledge graphs, Retrieval-Augmented Generation (RAG) models, and privacy-compliant patient record architectures, VaidyaMed-X assists healthcare providers and users with accurate symptom triage, preventative health recommendations, and verified clinical knowledge.',
    features: [
      'RAG-based medical & traditional wellness retrieval engine',
      'Clinical symptom analysis & initial triage assistance',
      'Secure, end-to-end encrypted health record storage',
      'Doctor-patient tele-consultation workflow',
      'Low-latency lightweight inference engine'
    ],
    techStack: ['Python', 'FastAPI', 'FAISS Vector DB', 'React', 'Docker', 'PostgreSQL'],
    useCases: [
      'Primary clinic triage & pre-assessment',
      'Preventive health & wellness monitoring',
      'Tele-health consult management for remote regions'
    ],
    futureScope: [
      'Multilingual clinical voice transcription',
      'IoT wearable telemetry synchronization',
      'Decentralized health record auditing'
    ],
    demoLink: 'https://vaidyamedx.in'
  },
  {
    id: 'sudarshana-ai',
    aliases: ['ai-assistant', 'cybershield'],
    title: 'Sudarshana AI',
    domain: 'Cybersecurity',
    category: 'Cybersecurity & Intelligence',
    color: 'cyber',
    badge: 'Enterprise Security',
    shortDescription: 'An AI-powered cybersecurity and intelligence platform providing real-time anomaly detection, zero-trust perimeter defense, and automated threat mitigation.',
    fullDescription: 'Sudarshana AI is a proactive enterprise threat defense platform. Operating on high-throughput network streams, it utilizes deep behavioral anomaly detection models to intercept intrusion vectors, unauthorized privilege escalation, and zero-day vulnerabilities before they compromise infrastructure.',
    features: [
      'Real-time network traffic telemetry & anomaly detection',
      'Zero-trust security policy enforcement',
      'Automated incident triage and response workflows',
      'Cryptographic integrity and log tamper detection',
      'Threat intelligence correlation engine'
    ],
    techStack: ['Python', 'PyTorch', 'eBPF', 'FastAPI', 'Redis', 'Docker'],
    useCases: [
      'Enterprise cloud infrastructure protection',
      'Financial transaction security and intrusion alerts',
      'Critical server cluster defense'
    ],
    futureScope: [
      'Self-remediating cloud policy generators',
      'Decentralized threat intelligence exchange',
      'Automated penetration vector simulation'
    ]
  },
  {
    id: 'trinetra-ai',
    title: 'TRINETRA AI',
    domain: 'Artificial Intelligence',
    category: 'Media Forensics & Deepfake Detection',
    color: 'ai',
    badge: 'Deep-Tech AI',
    shortDescription: 'A multi-modal media authenticity and deepfake analysis platform engineered to detect synthetic voice, face manipulation, and generated audiovisual artifacts.',
    fullDescription: 'TRINETRA AI is a deep forensic inspection platform created to defend informational integrity. It applies spatial-temporal frequency analysis, biometric consistency checks, and neural pattern forensics to determine whether digital media (video, audio, or images) has been synthetically generated or altered by AI models.',
    features: [
      'Multi-spectral face manipulation and artifact detection',
      'Acoustic synthetic voice analysis & spectrogram forensics',
      'Real-time streaming media verification API',
      'Cryptographic watermarking & provenance verification',
      'Confidence scoring with forensic explainability reports'
    ],
    techStack: ['Python', 'TensorFlow', 'OpenCV', 'FFmpeg', 'Next.js', 'Kubernetes'],
    useCases: [
      'Digital identity KYC and remote verification',
      'Media house content verification & fact-checking',
      'Enterprise communication protection against executive impersonation'
    ],
    futureScope: [
      'Live video stream anti-spoofing browser extension',
      'Hardware-integrated camera sensor verification',
      'Tamper-proof blockchain provenance registries'
    ]
  },
  {
    id: 'roadresq-ai',
    title: 'RoadResQ AI',
    domain: 'Intelligent Mobility',
    category: 'Emergency Response & Telematics',
    color: 'mobility',
    badge: 'Mobility Tech',
    shortDescription: 'An AI-assisted emergency response and intelligent mobility platform that detects collisions in real-time and coordinates rapid responder dispatch.',
    fullDescription: 'RoadResQ AI combines edge sensor telematics, computer vision, and dynamic dispatch algorithms to cut emergency response times during vehicular incidents. When severe deceleration or crash patterns are detected, the system verifies the incident severity and provides emergency services with precise telemetry and routing.',
    features: [
      'Edge telematics crash detection & severity categorization',
      'Automated emergency services notification with GIS coordinates',
      'Optimal ambulance route computation taking traffic into account',
      'Pre-arrival medical telemetry dispatch to receiving hospitals',
      'Safe driving telematics & predictive hazard alerts'
    ],
    techStack: ['Python', 'Go', 'WebSockets', 'Leaflet / Mapbox', 'React Native', 'MQTT'],
    useCases: [
      'Commercial fleet safety and automated SOS response',
      'Municipal emergency service dispatch integration',
      'Highway authority safety telemetry systems'
    ],
    futureScope: [
      'V2X (Vehicle-to-Everything) cooperative crash avoidance',
      'Drone-based first-responder medical delivery coordination',
      'Insurance automated claim telemetry integration'
    ]
  },
  {
    id: 'sarathi-x',
    title: 'Sarathi-X',
    domain: 'Education & Cognitive Tech',
    category: 'EdTech & Cognitive Systems',
    color: 'edtech',
    badge: 'Cognitive Learning',
    shortDescription: 'An AI-powered learning and cognitive development platform that personalizes technical education through adaptive mastery graphs and intelligent feedback.',
    fullDescription: 'Sarathi-X is an educational engineering platform designed to transform how software engineering and technical skills are acquired. Using continuous knowledge state evaluation, it adjusts curriculum pacing, suggests targeted practice, and provides actionable code review feedback to learners in real time.',
    features: [
      'Dynamic knowledge graph tracking learner mastery',
      'Real-time automated code evaluation & architectural feedback',
      'Personalized adaptive practice curriculum',
      'Interactive technical milestone assessments',
      'Industry-standard competency benchmarking'
    ],
    techStack: ['Node.js', 'React', 'Python', 'FastAPI', 'PostgreSQL', 'Docker sandbox'],
    useCases: [
      'University and college technical skill upskilling',
      'Corporate developer onboarding and certification',
      'Self-paced developer mastery programs'
    ],
    futureScope: [
      'Collaborative peer-programming AI agent',
      'Multi-modal voice tutoring interface',
      'Automated enterprise skill gap analysis dashboard'
    ]
  },
  // Backward compatibility alias items:
  {
    id: 'cybershield',
    title: 'FAST + QTD CyberShield (Sudarshana Suite)',
    domain: 'Cybersecurity',
    category: 'Cybersecurity',
    color: 'cyber',
    badge: 'Security Module',
    shortDescription: 'Threat detection module utilizing AI-driven anomaly detection and real-time response framework.',
    fullDescription: 'FAST + QTD CyberShield is a proactive cybersecurity initiative providing zero-trust defense against emerging network vulnerabilities.',
    features: ['AI anomaly detection', 'FAST response framework', 'Proactive fraud prevention'],
    techStack: ['Python', 'Docker', 'Kubernetes'],
    useCases: ['Enterprise network security', 'Infrastructure defense'],
    futureScope: ['Self-healing architectures']
  },
  {
    id: 'vaidyamedx',
    title: 'VaidyaMed-X',
    domain: 'Healthcare Technology',
    category: 'HealthTech',
    color: 'health',
    badge: 'Health Platform',
    shortDescription: 'AI-assisted medical and wellness platform with RAG knowledge architecture.',
    fullDescription: 'VaidyaMed-X combines medical knowledge with intelligent diagnostic support and secure records.',
    features: ['RAG clinical retrieval', 'Symptom analysis', 'Telehealth records'],
    techStack: ['Python', 'FastAPI', 'React'],
    useCases: ['Clinical triage', 'Preventive health'],
    futureScope: ['Wearables integration'],
    demoLink: 'https://vaidyamedx.in'
  },
  {
    id: 'smart-waste',
    title: 'Smart Waste IoT System',
    domain: 'Sustainability',
    category: 'IoT & Smart City',
    color: 'sustain',
    badge: 'IoT Systems',
    shortDescription: 'IoT-enabled waste management telemetry and resource optimization platform.',
    fullDescription: 'An IoT telemetry solution for monitoring urban sanitation infrastructure efficiently.',
    features: ['Fill-level monitoring', 'Real-time telemetry', 'Municipal analytics'],
    techStack: ['ESP32', 'Node.js', 'React'],
    useCases: ['Campus waste optimization', 'Smart cities'],
    futureScope: ['Automated routing']
  }
];
